import { useRole } from '../../../../../hooks/useRole';
import { useUsername } from '../../../../../hooks/useUsername';
import { MessagingAttendee } from '../../../../../interfaces/interfaces';
import AttendeeAvatar from '../AttendeeAvatar';

interface AttendeeComponentInterface {
  attendee: MessagingAttendee;
  onClick: () => void;
  animationIndex: number;
  skipAnimation: boolean;
}
const AttendeeComponent = ({ attendee, animationIndex, skipAnimation, onClick }: AttendeeComponentInterface) => {
  const { isUserEventHost } = useRole();
  const { getConstructedName } = useUsername();

  const username = getConstructedName(attendee);
  const split = username?.split('|');

  return (
    <div
      key={attendee._id}
      className={`w-full px-4 py-2 flex flex-row items-center border-b-2 transition duration-200 ease-in-out bg-white hover:bg-slate-200 ${
        !skipAnimation ? 'attendeeDiv' : ''
      }`}
      onClick={() => onClick()}>
      <div className="px-4 h-full grid place-items-center" onClick={(e) => e.stopPropagation()}>
        <AttendeeAvatar attendee={attendee} showStatus isOrganizer={isUserEventHost(attendee as any)} />
      </div>
      <div className="text-md @lg:text-lg">
        {split && split.length > 1 ? (
          <>
            <b className="text-md @lg:text-lg">{split[0]}</b>
            <br />
            <p className="text-sm @lg:text-md">{split[1]}</p>
          </>
        ) : (
          <b>{getConstructedName(attendee)}</b>
        )}
      </div>
    </div>
  );
};
export default AttendeeComponent;
